const SeasonOffer = () => import("./views/season-offer.vue");
import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/season_offer",
      component: SeasonOffer,
      name: "Bid",
      meta: {
        groupName: "Private Sale",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
